function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.412 6l3.331 3.33a1 1 0 01-1.413 1.415L5.998 7.414l-3.331 3.331A1 1 0 011.253 9.33L4.584 6 1.253 2.669a1 1 0 011.414-1.414l3.331 3.331L9.33 1.255a.999.999 0 111.413 1.414L7.412 6z"
});

var SvgX = function SvgX(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy40MTIgNmwzLjMzMSAzLjMzYTEgMSAwIDAgMS0xLjQxMyAxLjQxNUw1Ljk5OCA3LjQxNGwtMy4zMzEgMy4zMzFBMSAxIDAgMCAxIDEuMjUzIDkuMzNMNC41ODQgNiAxLjI1MyAyLjY2OWExIDEgMCAwIDEgMS40MTQtMS40MTRsMy4zMzEgMy4zMzFMOS4zMyAxLjI1NWEuOTk5Ljk5OSAwIDEgMSAxLjQxMyAxLjQxNEw3LjQxMiA2eiIvPgo8L3N2Zz4K";
export { SvgX as ReactComponent };